import React from "react";
import { Link } from "react-router-dom";
import { classNames } from "../../helpers/classNames";

const Button = ({ buttonClasses, buttonType, buttonIcon, buttonIconPosition, buttonLabel, buttonLabelClasses, buttonFunction = () => { }, buttonHasLink, buttonLink, isDisable = false, ...props }) => {
  return (
    <>
      {buttonHasLink ? (
        <Link to={buttonLink} className={classNames("relative overflow-hidden flex justify-center items-center gap-2 bg-md-pink hover:bg-md-pink-dark text-white rounded-full text-lg h-12 py-0 px-5 transition-all duration-200", buttonClasses, isDisable ? "pointer-events-none font-Poppins" : "")}>
          {buttonIconPosition === "left" && <i className={classNames("fa-fw", buttonIcon)}></i>}
          {buttonLabel && <span className={classNames("text-base", buttonLabelClasses)}>{buttonLabel}</span>}
          {buttonIconPosition === "right" && <i className={classNames("fa-fw", buttonIcon)}></i>}
        </Link>
      ) : (
        <button type={buttonType} className={classNames("relative overflow-hidden flex justify-center items-center gap-2 bg-md-pink hover:bg-md-pink-dark text-white rounded-full text-lg h-12 py-0 px-5 transition-all duration-200", buttonClasses, isDisable ? "pointer-events-none opacity-75 font-Poppins" : "")} onClick={buttonFunction} disabled={isDisable}>
          {buttonIconPosition === "left" && <i className={classNames("fa-fw", buttonIcon)}></i>}
          {buttonLabel && <span className={classNames("text-base", buttonLabelClasses)}>{buttonLabel}</span>}
          {buttonIconPosition === "right" && <i className={classNames("fa-fw", buttonIcon)}></i>}
        </button>
      )}
    </>
  );
};

export default Button;
